/**
 * Scrolls to an element by ID using native scrollIntoView.
 * Target elements should set `scroll-margin-top` via the `--sticky-offset` CSS variable
 * (published by each page layout) so the scroll lands below the sticky headers.
 * @param elementId - The ID of the element to scroll to
 */
export function scrollToElementAfterDelay(elementId: string): void {
  requestAnimationFrame(() => {
    const element = document.getElementById(elementId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  })
}
